import { z } from "zod";

export const yearSchema = z
	.string()
	.length(4)
	.transform((year) => parseInt(year));

export const cupTeamSchema = z.object({
	name: z.string(),
	logo: z.string(),
});

export const cupDateSchema = z.object({
	day: z.string().transform((d) => parseInt(d)),
	month: z.string().transform((d) => parseInt(d)),
	monthName: z.string(),
	dayOfWeek: z.string(),
	year: z.string(),
	time: z.string().nullable(),
	format_day_month: z
		.object({
			name: z.string(),
			declensions: z.array(z.string()),
		})
		.nullable(),
});
